<template>
  <div class="cart-list-item">
    <b-table v-if="cartData.length > 0" :data="cartData" class="tile layout is-child vertical-middle">
      <template v-if="props.row.product" slot-scope="props">
        <b-table-column class="first-column" field="image_url" custom-key="image_url" width="120">
          <div class="img-resize img-resize--medium">
            <router-link :to="'/customer/product/detail/' + props.row.productId">
              <img
                :src="props.row.product.image[0] || require('@/assets/images/goods_default.svg')"
                alt="..."
                class="img-thumbnail"
              />
            </router-link>
          </div>
        </b-table-column>

        <b-table-column class="second-column" field="name_shop" custom-key="name_shop">
          <div class="name_shop word-break-all">
            <router-link :to="'/customer/shop/' + props.row.product.owner">
              <span v-line-clamp="1">{{ props.row.product.shopName }}</span>
            </router-link>
          </div>
          <div class="name_item pre-line-all">
            <router-link :to="'/customer/product/detail/' + props.row.productId">
              <span v-line-clamp="2">{{ props.row.product.name }}</span>
            </router-link>
          </div>
          <p v-if="getProductQuantity(props.row.product, props.row.propId) === -1" class="help is-danger error-text">
            {{ $t('EF2152_Content') }}
          </p>
          <p v-else-if="getProductQuantity(props.row.product, props.row.propId) < 1" class="help is-danger error-text">
            {{ $t('EF2141_Content') }}
          </p>
          <p
            v-else-if="getProductQuantity(props.row.product, props.row.propId) < props.row.quantity"
            class="help is-danger error-text"
          >
            {{ $t('EF2142_Content') }}
          </p>
          <div class="name_item_category word-break-all">
            <router-link :to="'/customer/product/detail/' + props.row.productId">
              <span>{{ getPropertyName(props.row.product.properties, props.row.propId) }}</span>
            </router-link>
          </div>
          <div>
            <span style="font-size: 13px; color: #4a4a4a;">{{ shippingDate(parseInt(props.row.product.detail.shipping_date)) }}</span>
          </div>

          <div class="delete_item">
            <a class="c-text-grey" @click="deleteProductFromCart(props.index)">
              <span>削除</span>
            </a>
          </div>
        </b-table-column>

        <b-table-column :centered="true" field="price" class="text-center text-column" label="単価" width="120">
          {{ formatPrice(props.row.product.price || 0) }} {{ $t('common.ETH') }}
        </b-table-column>

        <b-table-column :centered="true" field="amount" class="text-center number_prod" label="数量" width="160">
          <integer-plusminus
            :min="1"
            :max="getProductQuantity(props.row.product, props.row.propId) < 999 ? getProductQuantity(props.row.product, props.row.propId) : 999"
            v-model="props.row.quantity"
            :key="rdKey"
            @input="handleChange(props.row.quantity, $event, props.index)"
          >
            {{ props.row.quantity }}
            <template slot="decrement"
              >−</template
            >
            <template slot="increment"
              >+</template
            >
          </integer-plusminus>
        </b-table-column>

        <b-table-column :centered="true" field="total_price" class="text-center text-column" label="小計" width="120">
          <!--eslint-disable-next-line--><!--prettier-ignore-->
          {{ formatPrice((props.row.product.price || 0) * props.row.quantity) }}
          {{ $t('common.ETH') }}
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>
<style lang="scss" src="./cart-item.scss">
</style>

<script>
import dataTransform from '../../../../utils/mixins/dataTransform';
import { getProductQuantity } from '../../../../services/properties.service';
import { getProductDetail } from '../../../../services/product.service';
import { IntegerPlusminus } from 'vue-integer-plusminus';
import { truncate } from '@/utils/commonUtil';

export default {
  name: 'CartItem',
  components: {
    IntegerPlusminus
  },
  mixins: [dataTransform],
  props: {
    cartData: {
      type: Array,
      default: () => []
    },
    deleteProductFromCart: {
      type: Function,
      default: () => {}
    },
    handleInputChange: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      rdKey: 0
    };
  },
  watch: {
    cartData: function(newData) {
      // this.$forceUpdate();
      this.rdKey = Math.random();
    }
  },
  methods: {
    handleChange(oldValue, newValue, itemIndex) {
      const changeValue = Number(newValue) - Number(oldValue);
      this.handleInputChange(changeValue, itemIndex);
      this.rdKey = Math.random();
    },
    getPropertyName(properties, propId) {
      let title = '';
      const stocks = properties.stocks;
      stocks.forEach(stock => {
        if (stock.id === propId) {
          const stockAttributes = stock.attributes;
          const stockNames = stockAttributes.map(item => item.name);
          title = `- ${stockNames.join(', ')}`;
        }
      });

      return truncate(title, 30);
    },
    shippingDate(id) {
      const shippingDate = this.$t('shippingDate');
      return shippingDate && id > 0 ? `発送日の目安：入金後${shippingDate[id - 1].dates}` : '発送日の目安：';
    },
    getProductQuantity: getProductQuantity
  }
};
</script>
<style>
</style>
